module.exports = __webpack_public_path__ + "static/media/footer-ico1.26dee01c.svg";